/*  */
//import $ from 'jquery';
import $ from "jquery";

export const tableResponsive = (content) => {

    var test = $("<div class='article-parse'>" + content + "</div>");

    test.find("table").each(function() {
        $(this).addClass("table");
        $(this).removeAttr("border").removeAttr("cellpadding").removeAttr("cellspacing").removeAttr("align").removeAttr("style");
        $(this).wrap("<div class='table-responsive'></div>");
        $(this).addClass("aim--edit");
    });

    return test;

}
